<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols='12' md='4'>
          <basics v-if='project' :project='project' @update='update'></basics>
        </v-col>
        <v-col cols='12' md='4'>
          <lawn-details v-if='project' :project='project' @update='update'></lawn-details>
        </v-col>
        <v-col cols='12' md='4'>
          <lawn-rating v-if='project' :project='project' @update='update'></lawn-rating>
        </v-col>
        <v-col cols='12' md='6'>
          <contacts v-if='project' :project='project' @update='update'></contacts>
        </v-col>
        <v-col cols='12' md='6'>
          <quote-amounts v-if='project' :project='project'></quote-amounts>
        </v-col>
        <v-col cols='12' md='6'>
          <stickies v-if='project' :project='project'></stickies>
        </v-col>
      </v-row>
      <wc-page-section class='mt-n7' title='Files'></wc-page-section>
      <v-row>
        <v-col cols='12' md='12'>
          <project-files v-if='project' :files='project.project_file_data' :project_id='project.id'
            :disabled='project.archived'></project-files>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols='12' md='4'>
          <spring-cleanup-instructions v-if='project' :project='project' @update='update'></spring-cleanup-instructions>
        </v-col>
        <v-col cols='12' md='4'>
          <lawn-care-instructions v-if='project' :project='project' @update='update'></lawn-care-instructions>
        </v-col>
        <v-col cols='12' md='4'>
          <fertilizer-instructions v-if='project' :project='project' @update='update'></fertilizer-instructions>
        </v-col>
        <v-col cols='12' md='4'>
          <office-instructions v-if='project' :project='project' @update='update'></office-instructions>
        </v-col>
        <v-col cols='12' md='4'>
          <customer-notes v-if='project' :project='project' @update='update'></customer-notes>
        </v-col>
        <v-col cols='12' md='4'>
          <invoicing-notes v-if='project' :project='project' @update='update'></invoicing-notes>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols='12' md='4'>
          <wc-data-box title="Scheduling Considerations" :showEdit='false' :showHelp='false' helpText=''>
            <div class='px-4' style="font-size: 12px; padding-top: 10px; display: inline-flex; width: 100%;">
              <v-checkbox dense class='my-checkbox' color="blue" label="Call or Email Ahead"
                v-model='project.call_ahead' @change='updateSchedulingConsiderations($event, "call_ahead")' />
            </div>
          </wc-data-box>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Basics from '@/modules/projects/components/Basics';
import Contacts from '@/modules/projects/components/Contacts';
import LawnDetails from '@/modules/lawn/components/LawnDetails';
import QuoteAmounts from '@/modules/lawn/components/QuoteAmounts';
import LawnRating from '@/modules/lawn/components/LawnRating';
import ProjectFiles from '@/components/files/ProjectFiles';
import LawnCareInstructions from '@/modules/lawn/components/LawnCareInstructions';
import FertilizerInstructions from '@/modules/lawn/components/FertilizerInstructions';
import SpringCleanupInstructions from '@/modules/lawn/components/SpringCleanupInstructions';
import OfficeInstructions from '@/modules/projects/components/OfficeInstructions';
import CustomerNotes from '@/modules/projects/components/CustomerNotes';
import InvoicingNotes from '@/modules/projects/components/InvoicingNotes';
import Stickies from '@/modules/projects/components/Stickies';
import projectAPI from '@/api/project';

export default {
  name: 'lawn-overview',
  props: {
    project: {
      required: true
    }
  },
  methods: {
    update(project) {
      this.$emit('update', project)
    },
    async updateSchedulingConsiderations(event, option) {
      const update_values = {}

      if (option === "call_ahead") {
        update_values.call_ahead = event;
      }
      projectAPI.updateProject(this.project.id, update_values);
    }
  },
  components: {
    'basics': Basics,
    'contacts': Contacts,
    'lawn-details': LawnDetails,
    'spring-cleanup-instructions': SpringCleanupInstructions,
    'lawn-care-instructions': LawnCareInstructions,
    'fertilizer-instructions': FertilizerInstructions,
    'office-instructions': OfficeInstructions,
    'quote-amounts': QuoteAmounts,
    'lawn-rating': LawnRating,
    'project-files': ProjectFiles,
    'customer-notes': CustomerNotes,
    'invoicing-notes': InvoicingNotes,
    'stickies': Stickies
  }
}
</script>
<style scoped>
.my-checkbox .v-label {
  font-size: 12px;
}

::v-deep .my-checkbox .v-label {
  font-size: 12px;
}
</style>
